import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scroll to top on route change, EXCEPT when:
 *  - only the language segment (/ar/... <-> /en/...) changes
 *  - the destination has a hash (anchor scroll target)
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    const stripLang = (p) => p.replace(/^\/(ar|en)(?=\/|$)/, "") || "/";
    const prev = window.__prevPath;
    window.__prevPath = pathname;

    if (prev && stripLang(prev) === stripLang(pathname)) {
      return; // language switch only – keep scroll
    }
    if (hash) {
      return; // anchor navigation – let the page handle it
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
}
